@if(dropdownConfig().actions!.length <= 2 && !dropdownModeActive){
<section class="d-flex flex-row gap-1 justify-content-center">
  @for (config of config; track config) {
  <button-component [config]="config" [data]="data" />
  }
</section>

} @else{
<dropdown-component [config]="dropdownConfig()" [data]="data" />
}
